


































































































































































import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '../../store'
import { OperationItemType } from '../../types/type'
@Component({
  name: 'EnumType',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class EnumType extends Vue {
  public tableDataList: any[] = []
  public loading: boolean = true
  public dialogVisible: boolean = false
  public title: string = ''
  public descr: string = ''
  public ekey: string = ''
  public isOnlyLook: boolean = false
  public optionsTitle: string = ''
  public optionsDialogVisible: boolean = false
  public optionsList: any[] = []
  public optionsLoading: boolean = false
  public name: string = ''
  public value: string = ''
  public optionsSaveShow: boolean = false
  public whoekey: string = ''
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-circle-plus-outline m_r5'></span>新增枚举",
      key: 'add',
      type: 'primary',
      size: ''
    }
  ]

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  created () {
    this.getTableDataList()
  }

  addEnum () {
    this.title = '新增枚举'
    this.descr = this.ekey = ''
    this.dialogVisible = true
  }

  async getTableDataList () {
    try {
      let _that: any = this
      this.loading = true
      let { data: result } = await _that.$http.getEnumList()
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.tableDataList = result.data || []
    } catch (err) {
      console.log(err)
    }
  }

  async save () {
    try {
      if (!this.descr) return this.$message.warning('请输入枚举名称')
      if (!this.ekey) return this.$message.warning('请输入枚举标识')
      let _that: any = this
      let params = {
        descr: this.descr,
        ekey: this.ekey
      }
      let messageText: string = '新增成功'
      let { data: result } = await _that.$http.createEnum(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogVisible = false
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }

  async goOptions (item: any) {
    try {
      this.optionsTitle = '枚举选项'
      this.optionsSaveShow = false
      this.optionsDialogVisible = true
      this.whoekey = item.ekey
      let _that: any = this
      this.optionsLoading = true
      let { data: result } = await _that.$http.enumSelectList({
        key: item.ekey
      })
      this.optionsLoading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.optionsList = result.data
    } catch (err) {
      console.log(err)
    }
  }

  async optionsSave () {
    try {
      if (!this.name || !this.value) return this.$message.warning('请将信息填写完整')
      let _that: any = this
      let params = {
        ekey: this.whoekey,
        name: this.name,
        value: this.value
      }
      let messageText: string = '新增成功'
      var { data: result } = await _that.$http.createSelectOfEnum(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.optionsSaveShow = false
      let { data: result02 } = await _that.$http.enumSelectList({
        key: this.whoekey
      })
      this.optionsLoading = false
      if (result02.code !== 200) return this.$message.error(result02.msg)
      this.optionsList = result02.data
      this.name = this.value = ''
    } catch (err) {
      console.log(err)
    }
  }

  addNewOneOfOptions () {
    this.optionsSaveShow = true
  }

  operationForButton ({ key }, row) {
    switch (key) {
      case 'add':
        this.addEnum()
        break
    }
  }
}
